module.exports = __webpack_public_path__ + "img/1 (10).01e63e43.jpg";